<template>
    <div class="content">


      <div>
        <div style="padding-top: 20px;"></div>
      
        <div style="display: none;"></div>
        <div ref="alipayWeb" v-html="alipay" style="display: none;"></div>
        <div class="moble-form-class" v-if="isMobile">

            <div style="text-align: center;" v-if="!showPaymentForm">
              <h1>{{ server_name }}</h1>
              <p style="color: red;">充值比例：1 : {{ usd_scale }}</p>
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-if="!showPaymentForm">
               <el-form-item label="提示"><span style="color: crimson;font-size: xx-small;">(支付前請先搜索賬號是否存在，以免失敗)</span></el-form-item>
                <el-form-item label="賬號" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name" placeholder="請輸入遊戲賬號" >
                      <el-button slot="append" icon="el-icon-search" @click="queryAccount"></el-button>
                   
                    </el-input> 
                       
                </el-form-item>
                <el-form-item label="角色" prop="game_char_id" v-if="accounts.length > 0">
                  <el-tag type="success" v-for="(tag,index) in accounts" :key="index">{{ tag.game_char }}</el-tag>&nbsp;&nbsp;
                </el-form-item>
                <!--<el-form-item label="確認賬號" prop="agin_game_account_name">
                    <el-input v-model="ruleForm.agin_game_account_name"></el-input>     
                </el-form-item>-->
                <el-form-item label="金額(USD)" prop="amt">
                    <el-input-number v-model="ruleForm.amt" :min="10" :max="100000000" :step="10" @change="queryJF"></el-input-number>
                </el-form-item>
                <el-form-item label="備註" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>
            
        <div class="payment-container" v-if="showPaymentForm">
             <form id="payment-form">
              <div id="payment-element"></div>
              <button id="payment-button" type="submit" style="margin-bottom: 20px;">
                <span id="button-text">${{ ruleForm.amt }}支付</span>
              </button>
              <div id="error-message" role="alert"></div>
            </form>
          </div>


        </div>
         <div class="form-class" v-else>

            <div style="text-align: center;" v-if="!showPaymentForm">
              <h1>{{ server_name }}</h1>
              <p style="color: red;">充值比例：1 : {{ usd_scale }}</p>
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" v-if="!showPaymentForm">
               <el-form-item label="提示"><span style="color: crimson;font-size: xx-small;">(支付前請先搜索賬號是否存在，以免失敗)</span></el-form-item>
                <el-form-item label="賬號" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name" placeholder="請輸入遊戲賬號" >
                      <el-button slot="append" icon="el-icon-search" @click="queryAccount"></el-button>
                   
                    </el-input> 
                       
                </el-form-item>
                <el-form-item label="角色" prop="game_char_id" v-if="accounts.length > 0">
                  <el-tag type="success" v-for="(tag,index) in accounts" :key="index">{{ tag.game_char }}</el-tag>&nbsp;&nbsp;
                </el-form-item>
                <!--<el-form-item label="確認賬號" prop="agin_game_account_name">
                    <el-input v-model="ruleForm.agin_game_account_name"></el-input>     
                </el-form-item>-->
                <el-form-item label="金額(USD)" prop="amt">
                    <el-input-number v-model="ruleForm.amt" :min="10" :max="100000000" :step="10" @change="queryJF"></el-input-number>
                </el-form-item>
                <el-form-item label="備註" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>
            
        <div class="payment-container" v-if="showPaymentForm">
             <form id="payment-form">
              <div id="payment-element"></div>
              <button id="payment-button" type="submit" style="margin-bottom: 20px;">
                <span id="button-text">${{ ruleForm.amt }}支付</span>
              </button>
              <div id="error-message" role="alert"></div>
            </form>
          </div>

        </div>
      </div>

    </div>
</template>
<script>
import {Form, Message} from 'element-ui';
import { config } from '@/utils/config';
import { loadStripe } from '@stripe/stripe-js';
  export default {
    data() {
      return {
        toPayUrl:null,
        toPrice:null,
        toAccountName:null,
        elements:null,
        paymentIntentId : null,
        show:false,
        checkout:null,
        stripe: null,
        cardElement: null,
        paymentElement: null,
        clientSecret: null,
        loading: false,
        showPaymentForm: false,
        paymentLoading: false,
        paymentStatus: null,
        errorMessage: '',
        isMobile: false,
        ruleForm: {
          customeName:null,
          serviceId:'',
          service_id:'',
          usdt:3,
          remark:'',
          game_account_name:'',
          user_type:0,
          amt:10
        },
        qjf:{},
        commission:0.003,
        accounts:[],
        paymentType:false,
        payBtn:false,
        tip:'請掃碼支付',
        tipFlag:true,
        options:[],
        u_scale : 1,
        usd_scale:1,
        orderNo:'',
        server_name:'',
        alipay:'',
        out_pay_url:'',
        rules: {
          amt: [
            { required: true, message: '請填寫金額', trigger: 'blur' },
            
          ],
          game_account_name: [
            { required: true, message: '請輸入遊戲賬號', trigger: 'blur' },
          ],
        }
      };
    },
    async created(){
        this.isMobile = window.innerWidth < 768;
        console.log(this.isMobile);
        let self = this;
        var url = window.location.href ;             //獲取當前url
        var cs={};
        if(url.indexOf('#') > -1 && url.indexOf('?') > -1 &&  url.indexOf('&') > -1){ 
            var dz_url = url.split('#')[0];                //獲取#/之前的字符串
            var csstr = dz_url.split('?')[1];                //獲取?之後的參數字符串
            var cs_arr = csstr.split('&');                    //參數字符串分割為數組
       
            for(var i=0;i<cs_arr.length;i++){         //遍歷數組，拿到json對象
              if(cs_arr[i]){
                if(cs_arr[i].split('=')){
                  cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1] 
                }
              }
            }
        }
    
        if(cs.service_id){ 
           //這樣就拿到了參數中的數據
            self.ruleForm.serviceId = cs.service_id;   
     
        }else{
            self.ruleForm.serviceId = '44f714b60a064f738b1dd56a9c16ad4c'
        }
        self.ruleForm.service_id = self.ruleForm.serviceId;    
        this.getParam();
      
        this.queryJF();
         this.stripe = await loadStripe(config.stripeApiPublicKey); 
        
         
    },
    methods: {
    

      queryAccount(){
        let self = this;
        self.postRequest('/game/characters_list',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.accounts = resp.data;
        })
      },
      queryJF(){
        let self = this;
        this.ruleForm.price = self.ruleForm.amt;
        self.postRequest('/order/integral_price',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.qjf = resp.data;
        })
      },
      async submitForm(formName) {
          let self = this;
          if(self.toPrice==self.ruleForm.amt&&self.toAccountName==self.ruleForm.game_account_name){
            let resp = await self.getRequest('/stripe/'+self.paymentIntentId);
            
            self.payBtn=false;
            let f = false;
            if(resp.err != 0){
              Message.error({message: resp.data});
              return;
            }
            console.log(resp.data);
            const paymentIntent = resp.data;
            // 获取初步状态
              let status = paymentIntent.status;
              // 如果看起来支付成功，再向服务器进行验证
              if (status === 'succeeded' || status === 'processing') {
                f = true;
              } 
            
            if(!f){
              if(self.isMobile){
                location.href = self.toPayUrl;
              }else{
                window.open(self.toPayUrl, '_blank');
              }
              return; 
            }
          }

          self.payBtn = true;
          self.$refs[formName].validate((valid) => {
          if (valid) {
            self.ruleForm.currency = 'TWD'
            self.postRequest('/stripe/pay',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err != 0){
                    Message.error({message: resp.data});
                    return;
                 }
                console.log(resp.data);
                if(resp.data){
                  self.clientSecret = resp.data.clientSecret;
                  self.paymentIntentId = resp.data.paymentIntentId;
                  const payUrl = 'https://ccmaple.cc/PaymentConfirm?price='+self.ruleForm.amt+"&clientSecret="+self.clientSecret;
                  this.toPayUrl = payUrl;
                  this.toPrice = self.ruleForm.amt;
                  this.toAccountName = self.ruleForm.game_account_name;
                 // 参数1：链接，参数2：新标签页名称（可空），参数3：窗口配置（可选）
                  if(this.isMobile){
                    location.href = payUrl;
                  }else{
                    window.open(payUrl, '_blank');
                  }
                  //this.showPaymentForm = true;
                  //this.setupCardElement();
                }
            })
          } else {
            self.payBtn=false;
            console.log('error submit!!');
            return false;
          }
        });
      },

       setupCardElement() {
                    this.showPaymentForm = true;
      // 在下一个渲染周期中创建Card Element
      this.$nextTick(() => {
        const elements = this.stripe.elements({
          clientSecret: this.clientSecret,//'pi_3ShlB98cwYPKzEDf1wBXQF1J_secret_O8mFH3Yxl2LSBnApVpkC9a2li',
          appearance: {   theme: 'stripe', },
        });
        

        // 创建Payment Element并配置
        this.paymentElement = elements.create('payment', {
          fields: {
            billingDetails: {
              name: 'auto', // 因为我们已经有了自定义的姓名字段
              email: 'auto',
              phone: 'auto',
              address: {
                line1: 'auto',
                line2: 'auto',
                city: 'auto',
                state: 'auto',
                postalCode: 'auto',
                country: 'auto' // 只显示国家选择器
              }
            }
          }
        });
        this.paymentElement.mount('#payment-element');
        // 处理表单提交
        const form = document.getElementById('payment-form');
       const button = document.getElementById('payment-button');
       const errorMessage = document.getElementById('error-message');
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          
          // 禁用按钮防止重复点击
          button.disabled = true;
          
          // 确认支付 - 内置字段的值将自动被收集和提交
          const { error } = await this.stripe.confirmPayment({
            elements,
            confirmParams: {
              //billing_details:  {
              //  name: 'auto', // 因为我们已经有了自定义的姓名字段
              //  email: 'auto',
              //  phone: 'auto',
              //  address: {
              //    line1: 'auto',
              //    line2: 'auto',
              //    city: 'auto',
              //    state: 'auto',
              //    postalCode: 'auto',
              //    country: 'auto' // 只显示国家选择器
              //  }
              //},  // 显示所有账单详情字段
              return_url: 'https://api.maplez.cc/#/paymentsuccess',
            },
          });

          if (error) {
            // 显示错误信息
            errorMessage.textContent = error.message;
            button.disabled = false;
          }
          // 成功时不需要额外处理，Stripe会自动重定向用户
        });
             
        
      });
    },
    
    
    async updateOrderStatus(paymentIntentId) {
      // 向您的服务器发送请求更新订单状态
      try {
        let data = {};
        data.paymentIntentId = paymentIntentId;
          this.postRequest('/stripe/verify',data).then(resp =>{
              self.payBtn=false;
              if(resp.err >= 500){
                Message.error({message: resp.msg});
                return;
              }
              console.log(resp.data);
        })
      } catch (error) {
        console.error('更新订单状态失败', error);
      }
    },

      getParam(){
        let self = this;
  
        console.log("this.ruleForm.service_id:"+self.ruleForm.service_id);

        self.postRequest('/game/servers_detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                self.out_pay_url = resp.data.out_pay_url;
                self.u_scale = resp.data.u_scale;
                document.title = resp.data.service_name;
                self.server_name = resp.data.service_name;
                self.usd_scale = resp.data.usd_scale;
            })

       

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      
  
      handleClose(done) {
        this.$confirm('確認關閉？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    },
  }
</script>
<style scoped>

    .content{
     
        margin-top: 50px;
        width: 100%;
          /* 水平垂直都居中 */
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
   
      
    }
    .form-class{
        padding-top: 50px;
        padding-left: 100px;
        padding-right: 100px;
        width: 100%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(253, 250, 250);
        border-radius: 20px;
     
    }
    .moble-form-class{
      padding-top: 30px;
       width: 100%;
        height: 500px;
        max-height: 800px;
        background-color: rgb(55, 155, 153);
        border-radius: 20px;
    }
.payment-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
}

.order-form, .payment-form, .payment-status {
  margin-bottom: 20px;
}

#card-element {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 16px;
}

button {
  background-color: #6772e5;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.error {
  color: #e25950;
  margin: 8px 0;
}

.success {
  color: #43a047;
}
</style>